import React, { useCallback, useEffect, useState } from "react";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import { DefaultSelectFilter } from "../../../../components/inputs/defaultSelectFilter";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import PaginationComponent from "../../../../components/table/tablePagination";
import SalaryTable from "./components/table";
import {
  getManageSalary,
  updateSalary,
} from "../../../../../services/workspace/payroll.service";
import { getDepartmentList } from "../../../../../services/workspace/department.service";
import DefaultSearchSelectInput from "../../../../components/inputs/defaultSearchSelectInput";
import { _fetchDepartments } from "../../../../../store/actions/configuration";
import DefaultButton from "../../../../components/buttons/defaultButton";

const items = [
  { label: "Home", path: "/" },
  { label: "Payroll", path: "/payroll" },
  { label: "Manage Salary", path: "" },
];

const transformData = (data = []) => {
  if (!Array.isArray(data)) return [];
  const formatData = data.map((item) => {
    const { salary } = item || {};
    return {
      id: item?.user_id,
      basic_salary: salary?.basic_salary || 0,
      transport_allowance: salary?.transport_allowance || 0,
      special_allowance: salary?.special_allowance || 0,
      net_salary: salary?.net_salary || 0,
      name: `${item?.first_name || ""} ${item?.last_name || ""}`.trim() || "-",
      profile_image: item?.user?.profile_image,
      doj: item?.created_at,
      email: item?.user?.email,
    };
  });
  return formatData;
};

function ManageSalary() {
  const dispatch = useDispatch();
  const { limit } = useSelector((state) => state.global);
  const [search, setSearch] = useState("");
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [selectDepartment, setSelectDepartment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedValue, setSelectedValue] = useState("desc");
  const { departments } = useSelector((state) => state.configuration);
  const [submiteLoading, setSubmiteLoading] = useState(false);
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const fetchData = () => {
    if (selectDepartment && selectDepartment.value) {
      setLoading(true);
      // getManageSalary({ search, page: currentPage, limit });
      getManageSalary({
        department_id: selectDepartment.value,
        order_by: "created_at",
        order_type: selectedValue,
        search,
      })
        .then((response) => {
          setLoading(false);
          setTableData(transformData(response || []));
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Failed to fetch salary data!");
          console.error("Error fetching data: ", error);
        });
    }
  };

  useEffect(() => {
    const timer = setTimeout(fetchData, search ? 500 : 0); // Debounce search input
    return () => clearTimeout(timer);
  }, [selectDepartment, selectedValue, search]);

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const updateSallery = (id, col, data) => {
    
    setTableData((prevData) =>
      prevData.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [col]: data };
  
          const getNumber = (value) => (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
  
          updatedItem["net_salary"] =
            getNumber(updatedItem["basic_salary"]) +
            getNumber(updatedItem["transport_allowance"]) +
            getNumber(updatedItem["special_allowance"]);
  
          return updatedItem;
        }
        return item;
      })
    );
  };
  

  const handelUpdateSalary = () => {
    let examTypeData = [];
    setSubmiteLoading(true);
    tableData.map((item) => {
      examTypeData.push({
        id: item.id,
        basic_salary: item.basic_salary,
        transport_allowance: item.transport_allowance,
        special_allowance: item.special_allowance,
        net_salary: item.net_salary,
      });
    });
    const payload = {
      users: examTypeData,
      department_id: selectDepartment.uuid,
    };
    updateSalary(payload)
      .then((response) => {
        toast.success("Salary update successfully!");
      })

      .catch((error) => {
        // setIsSubmitting(false);
        toast.error("Failed to salary update!" + error.response.data?.message);
      })
      .finally(() => {
        setSubmiteLoading(false);
      });
  };

  useEffect(() => {
    dispatch(_fetchDepartments());
  }, []);
  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={true}
        onSearchChange={handleSearchChange}
        isFilter={false}
        buttons={false}
      />

      <div className=" flex flex-col ">
        <div className="flex flex-row gap-2 p-4 text-theme font-bold items-center bg-white">

          <DefaultSelectFilter
            className="bg-light hover:bg-bghoverlight px-2 rounded-md flex flex-row gap-1"
            label="Sort By"
            options={[
              { label: "Newest First", value: "desc" },
              { label: "Oldest First", value: "asc" },
            ]}
            name={"filter"}
            onChange={handleSelectChange}
            // error={isError}
            errorMsg="Please select an option"
          />
          <div className="flex flex-row items-center bg-white gap-2">
            <span>Department</span>
            <DefaultSearchSelectInput
              name="department_id"
              value={selectDepartment}
              options={departments}
              onChange={(e) => {
                setSelectDepartment(e);
              }}
              customClass="w-100"
            />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <SalaryTable
            tableData={tableData}
            loading={loading}
            search={search}
            updateSallery={updateSallery}
          />
        </div>
      </div>
      {tableData && !!tableData.length && !loading && (
        <div className="flex flex-row gap-2 items-center">
          <DefaultButton
            minWidth
            name="Save"
            variant=""
            onClick={handelUpdateSalary}
            loading={submiteLoading}
          />
        </div>
      )}
    </div>
  );
}

export default ManageSalary;
